import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, ClipboardList, MessageSquare, Phone, BarChart3, LogOut, RefreshCw, User } from 'lucide-react';
import { Button } from '../components/ui/button';
import AgentClients from '../components/agent/AgentClients';
import AgentTasks from '../components/agent/AgentTasks';
import AgentDashboard from '../components/agent/AgentDashboard';

const AgentPanel = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('dashboard');
  const [agent, setAgent] = useState(null);

  useEffect(() => {
    const agentData = localStorage.getItem('agent');
    if (!agentData) {
      navigate('/agent');
      return;
    }
    setAgent(JSON.parse(agentData));
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('agent');
    navigate('/');
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  const tabs = [
    { id: 'dashboard', label: 'Dashboard', icon: BarChart3 },
    { id: 'clients', label: 'My Clients', icon: Users },
    { id: 'tasks', label: 'Tasks', icon: ClipboardList },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <AgentDashboard agent={agent} />;
      case 'clients':
        return <AgentClients agent={agent} />;
      case 'tasks':
        return <AgentTasks agent={agent} />;
      default:
        return <AgentDashboard agent={agent} />;
    }
  };

  if (!agent) {
    return null;
  }

  return (
    <div className="min-h-screen bg-slate-50 text-slate-800">
      {/* Header */}
      <header className="border-b border-slate-200 bg-white shadow-sm sticky top-0 z-40">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center">
                <User className="w-6 h-6 text-white" />
              </div>
              <div>
                <h1 className="text-xl font-bold bg-gradient-to-r from-blue-400 to-blue-700 bg-clip-text text-transparent">
                  Sales Agent Panel
                </h1>
                <p className="text-xs text-slate-500">{agent.name} - {agent.email}</p>
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <Button variant="ghost" size="sm" onClick={handleRefresh}>
                <RefreshCw className="w-4 h-4" />
              </Button>
              <Button variant="ghost" size="sm" onClick={handleLogout}>
                <LogOut className="w-4 h-4" />
              </Button>
            </div>
          </div>
        </div>
      </header>

      {/* Navigation */}
      <nav className="border-b border-slate-200 bg-white">
        <div className="container mx-auto px-4">
          <div className="flex space-x-1">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`px-4 py-3 flex items-center space-x-2 border-b-2 transition-colors ${
                    activeTab === tab.id
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-slate-500 hover:text-slate-800'
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  <span>{tab.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      </nav>

      {/* Content */}
      <main className="container mx-auto px-4 py-8">
        {renderContent()}
      </main>
    </div>
  );
};

export default AgentPanel;
